module.exports = __webpack_public_path__ + "assets/img/新西兰国旗@2x.bd16f9ec.png";